export default __webpack_public_path__ + "static/media/moto.c5319ff4.png";